<template>
    <div id="side-menu-bar">
        <router-link
            to="/chatbot/stories"
            :class="{ active: selectedPage === 'stories' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.stories.view'].tr.name)"
        >
            {{ $t("chatbotv2.ChatbotScenarioList") }}
        </router-link>
        <router-link to="/chatbot/stories" :class="{ active: selectedPage === 'stories' }" class="menu sub-menu"
            >{{ $t("chatbotv2.Scenario") }}
        </router-link>
        <router-link
            to="/chatbot/templates"
            :class="{ active: selectedSubPage === 'templates' }"
            class="menu sub-menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.templates.view'].tr.name)"
            >{{ $t("chatbotv2.templates") }}
        </router-link>
        <router-link
            to="/chatbot/ai/templates"
            :class="{ active: selectedSubPage === 'ai-templates' }"
            class="menu sub-menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.aitemplates.view'].tr.name)"
            >{{ $t("chatbotv2.aitemplates") }}
        </router-link>

        <router-link
            to="/chatbot/integrations"
            :class="{ active: selectedPage === 'integrations' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.integrations.view'].tr.name)"
            >{{ $t("chatbotv2.integrations") }}
        </router-link>
        <router-link
            to="/chatbot/archive"
            :class="{ active: selectedPage === 'archive' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.archive.view'].tr.name)"
            >{{ $t("chatbotv2.archive") }}
        </router-link>
        <router-link
            to="/chatbot/entities"
            :class="{ active: selectedPage === 'entities' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.entities.view'].tr.name)"
            >{{ $t("chatbotv2.entities") }}
        </router-link>

        <router-link
            to="/chatbot/reports/all-chats"
            :class="{ active: selectedPage === 'reports' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.reports.view'].tr.name)"
            >{{ $t("chatbotv2.reports") }}
        </router-link>
        <router-link
            v-if="chatBotGenel"
            to="/chatbot/reports/overall"
            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'overall' }"
            class="menu sub-menu"
            >Overall
        </router-link>
        <router-link
            to="/chatbot/reports/all-chats"
            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'all-chats' }"
            class="menu sub-menu"
            >{{ $t("chatbotv2.allChats") }}
        </router-link>
        <router-link
            to="/chatbot/reports/busiest-period"
            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'busiest-period' }"
            class="menu sub-menu"
            >{{ $t("chatbotv2.busiestPeriod") }}
        </router-link>
        <router-link
            to="/chatbot/reports/rating-distribution"
            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'rating-distribution' }"
            class="menu sub-menu"
            >{{ $t("chatbotv2.ratingDistribution") }}
        </router-link>
        <router-link
            to="/chatbot/reports/popularity"
            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'popularity' }"
            class="menu sub-menu"
            >{{ $t("chatbotv2.popularity") }}
        </router-link>

        <!--        <router-link-->
        <!--            to="/chatbot/reports/paid-chats"-->
        <!--            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'paid-chats' }"-->
        <!--            class="menu sub-menu"-->
        <!--            >{{ $t("chatbotv2.paidChats") }}-->
        <!--        </router-link>-->

        <!--        <router-link-->
        <!--            to="/chatbot/reports/all-messages"-->
        <!--            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'all-messages' }"-->
        <!--            class="menu sub-menu"-->
        <!--            >{{ $t("chatbotv2.allMessages") }}-->
        <!--        </router-link>-->
        <!--        <router-link-->
        <!--            to="/chatbot/reports/avarage-messages"-->
        <!--            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'avarage-messages' }"-->
        <!--            class="menu sub-menu"-->
        <!--            >{{ $t("chatbotv2.avarageMessages") }}-->
        <!--        </router-link>-->

        <!--        <router-link-->
        <!--            to="/chatbot/reports/all-users"-->
        <!--            :class="{ hidden: selectedPage !== 'reports', active: selectedSubPage === 'all-users' }"-->
        <!--            class="menu sub-menu"-->
        <!--            >{{ $t("chatbotv2.allUsers") }}-->
        <!--        </router-link>-->

        <router-link
            to="/chatbot/training"
            :class="{ active: selectedPage === 'training' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.training.view'].tr.name)"
            >{{ $t("chatbotv2.training") }}
        </router-link>
        <router-link
            to="/chatbot/user-segments"
            :class="{ active: selectedPage === 'user-segments' }"
            class="menu"
            v-if="checkPermission(PERMISSION_TYPES['chatbot.usersegments.view'].tr.name)"
            >{{ $t("chatbotv2.userSegments") }}
        </router-link>
        <router-link to="/chatbot/plans" :class="{ active: selectedPage === 'plans' }" class="menu">
            {{ $t('message.planManagement') }}
        </router-link>
    </div>
</template>

<script>
import CONFIG from "../../../config/config";
import { PERMISSION_TYPES } from "../../../language/permissionTypes";
import { mapGetters } from "vuex";

export default {
    name: "SideMenuBar",
    computed: {
        PERMISSION_TYPES() {
            return PERMISSION_TYPES;
        },
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    props: {
        selectedPage: {
            type: String,
        },
        selectedSubPage: {
            type: String,
        },
    },
    data() {
        return {
            openKeys: [],
            chatBotGenel: CONFIG.CHATBOT_RAPOR.enabled,
        };
    },
    methods: {},
    mounted() {},
};
</script>

<style lang="scss">
#side-menu-bar {
    background-color: #f5f8fb;
    box-shadow: inset -7px -1px 25px -5px #d1dfec;
    padding: 20px 30px;
    height: 100%;

    .menu {
        word-wrap: break-word;
        color: #22272d;
        max-width: 100%;
        padding: 5px 0;
        font-weight: bold;
        cursor: pointer;
        transition: all 0.3s;
        display: block;

        &:hover {
            color: #008aff;
            opacity: 0.8;
        }

        &.active {
            color: #008aff;
            opacity: 0.8;
        }
    }

    .sub-menu {
        margin-left: 1rem;
        font-weight: 400;
        padding: 0;

        &.active {
            color: #008aff;
            opacity: 0.8;
        }

        &.hidden {
            display: none;
        }
    }

    .router-link-active {
        color: #008aff;
        opacity: 0.8;
    }
}

.ant-menu-inline {
    border: none;
    background-color: transparent;

    li {
        .ant-menu-submenu-title {
            padding: 0 !important;
            margin: 0 !important;

            i {
                display: none;
            }
        }

        ul {
            background-color: transparent !important;

            .ant-menu-item {
                padding-left: 0px !important;
            }
        }
    }
}
</style>
